import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache the rates dict for the lifetime of the page (rates change daily; reload is fine)
let _ratesCache = null;
let _ratesPromise = null;

export function fetchRatesOnce() {
  if (_ratesCache) return Promise.resolve(_ratesCache);
  if (_ratesPromise) return _ratesPromise;
  _ratesPromise = axios.get(`${API}/fx/rates`).then((r) => {
    _ratesCache = r.data;
    return r.data;
  }).catch(() => {
    _ratesCache = { base: "USD", rates: { USD: 1 }, source: "fallback" };
    return _ratesCache;
  });
  return _ratesPromise;
}

/**
 * useFxRates() — returns { rates, base, loaded, convert(amount, from, to) }
 * `convert` is synchronous once `loaded` is true.
 */
export function useFxRates() {
  const [data, setData] = useState(_ratesCache);
  useEffect(() => {
    let alive = true;
    if (!_ratesCache) {
      fetchRatesOnce().then((d) => { if (alive) setData(d); });
    }
    return () => { alive = false; };
  }, []);

  const convert = (amount, from = "USD", to = "USD") => {
    if (!data || !data.rates) return amount;
    const fromR = data.rates[from] ?? 1;
    const toR = data.rates[to] ?? 1;
    const usd = amount / fromR;
    return Math.round(usd * toR * 100) / 100;
  };

  return { data, rates: data?.rates || {}, base: data?.base || "USD", loaded: !!data, convert };
}
